import React, {useEffect, useState} from "react";
import {getJSON, post, startFreshDemo, page, darkBtn, rankAccent, Portrait, Countdown} from "./ui";

export const ScoresPhase = ({state, offset, history}) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        let live = true;
        const tick = () => getJSON('/demo/scores').then(d => { if (live && d) setData(d); });
        tick();
        const id = setInterval(tick, 1000); // scores stream in as the AI judges
        return () => { live = false; clearInterval(id); };
    }, [state.round, state.phase]);

    if (!data) return <div style={{...page, alignItems: 'center', justifyContent: 'center'}}>…</div>;
    if (data.is_final) return <Winner data={data} state={state} history={history} />;

    return <div style={page}>
        <Countdown endsAt={state.phase_ends_at} offset={offset} />
        <div style={{textAlign: 'center', fontWeight: 900, fontStyle: 'italic', fontSize: 30, letterSpacing: 1, marginTop: 88}}>ROUND {data.round} SCORES</div>
        <Standings standings={data.standings} />
        {state.is_host && <button style={darkBtn} onClick={() => post('/demo/advance')}>
            {state.round < state.rounds_total ? 'Next round →' : 'Crown the winner →'}
        </button>}
    </div>;
};

// One combined card per player: the leaderboard row, with that player's guess
// results for the round underneath it.
const PlayerCard = ({s, rank}) => {
    const accent = rankAccent(rank);
    return <div className={`highscores-${rank <= 5 ? rank : 5}`} style={{overflow: 'hidden', boxSizing: 'border-box'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: 12, padding: '0 14px', height: 100, overflow: 'hidden'}}>
            <div style={{position: 'relative', zIndex: 1, fontSize: 32, fontWeight: 900, fontStyle: 'italic', width: 22, textAlign: 'center', flexShrink: 0, color: accent, textShadow: `0 0 12px ${accent}aa, 2px 2px 0 rgba(0,0,0,0.95)`}}>{rank}</div>
            <Portrait player={s} size={132} style={{alignSelf: 'flex-start', marginLeft: -22, marginRight: 0}} />
            <div style={{flex: 1, minWidth: 0}}>
                <div style={{fontSize: 22, fontWeight: 800, lineHeight: 1.1, textShadow: '2px 2px 0 rgba(0,0,0,0.9)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{s.name}</div>
                {s.nickname && <div style={{fontSize: 15, fontStyle: 'italic', opacity: 0.85, lineHeight: 1.15, textShadow: '1px 1px 0 rgba(0,0,0,0.9)'}}>{s.nickname}</div>}
            </div>
            <div style={{fontSize: 36, fontWeight: 900, color: accent, textShadow: `0 0 12px ${accent}aa, 2px 2px 0 rgba(0,0,0,0.95)`}}>{s.score}</div>
        </div>
    </div>;
};

const Standings = ({standings}) => (
    <div style={{display: 'flex', flexDirection: 'column', gap: 6}}>
        {standings.map((s, i) => <PlayerCard key={i} s={s} rank={i + 1} />)}
    </div>
);

const Winner = ({data, state, history}) => {
    const again = () => startFreshDemo(history);
    return <div style={page}>
        <div style={{textAlign: 'center', fontWeight: 900, fontStyle: 'italic', fontSize: 30, letterSpacing: 2, color: '#f1d28b', textShadow: '0 0 18px #f1d28baa'}}>CHAMPION 👑</div>
        <Standings standings={data.standings} />
        {state.is_host && <button style={darkBtn} onClick={again}>Run it again</button>}
    </div>;
};
